/* ==========================================================================
   Ambury product buy-column behaviour.

   Delegated at document level and scoped to the nearest [data-ambury-pdp]
   root, NOT to a section id. That matters: Dawn's quick-add modal fetches the
   product page, lifts out <product-info> and injects it elsewhere in the DOM,
   so any handler bound to #shopify-section-... would not follow the markup and
   size switching inside the modal would silently do nothing.

   Labels come from data attributes on the root, so they travel with the
   injected markup too.

   Every lookup is guarded: each element lives in a block the merchant can
   delete, and deleting one must not stop the others updating.
   ========================================================================== */
(function () {
  'use strict';

  function rootFor(el) {
    return el && el.closest ? el.closest('[data-ambury-pdp]') : null;
  }

  function label(root, name, fallback) {
    var v = root.getAttribute(name);
    return v === null || v === '' ? fallback : v;
  }

  function apply(root, radio) {
    if (!root || !radio) return;

    var price = radio.getAttribute('data-price') || '';
    var available = radio.getAttribute('data-available') === 'true';
    var netqty = radio.getAttribute('data-netqty') || '';
    var retail = radio.getAttribute('data-retail') || '';
    var title = radio.getAttribute('data-title') || '';

    var addLabel = label(root, 'data-add-label', 'Add to bag');
    var soldOutLabel = label(root, 'data-soldout-label', 'Sold out');
    var unavailableLabel = label(root, 'data-unavailable-label', 'Unavailable');
    var selectedSuffix = label(root, 'data-selected-suffix', 'selected');
    var showPrice = root.getAttribute('data-show-price-in-button') !== 'false';

    function one(sel) { return root.querySelector(sel); }

    /* the hidden input product-form.js reads as [name=id] */
    var input = one('[data-variant-input]');
    if (input) input.value = radio.value;

    var priceEl = one('[data-price]');
    if (priceEl) priceEl.textContent = price;

    var oursEl = one('[data-our-price]');
    if (oursEl) oursEl.textContent = price;

    var retailEl = one('[data-retail]');
    if (retailEl) retailEl.textContent = retail;

    var netqtyEl = one('[data-netqty]');
    if (netqtyEl) netqtyEl.textContent = netqty;

    var netqtyRow = one('[data-netqty-row]');
    if (netqtyRow) netqtyRow.textContent = netqty;

    var selectedEl = one('[data-selected-value]');
    if (selectedEl) selectedEl.textContent = (title + ' ' + selectedSuffix).trim();

    var submit = one('[data-submit]');
    if (submit) submit.disabled = !available;

    var submitText = one('[data-submit-text]');
    if (submitText) {
      if (!available) {
        submitText.textContent = soldOutLabel || unavailableLabel;
      } else {
        submitText.textContent = showPrice ? addLabel + ' — ' + price : addLabel;
      }
    }

    /* Only rewrite the address bar on a real product page. Inside the quick-add
       modal the visitor is still on the homepage and the URL must not change. */
    if (root.ownerDocument === document && document.body.classList.contains('template-product')) {
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* non-fatal */ }
      }
    }
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.hasAttribute || !radio.hasAttribute('data-pdp-size')) return;
    if (!radio.checked) return;
    apply(rootFor(radio), radio);
  });
})();
